<template>
  <div>
    <v-navigation-drawer
      v-model="open"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="open"
      hide-overlay
      class="z-index--100 drawer">
      <div class="ma-3">
        <div class="d-flex">
          <v-btn
            dark
            fab
            outlined
            color="primary"
            class="mr-3"
            @click="closePanel"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div class="subtitle-1 primary--text my-auto">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.title') }}
          </div>
        </div>
        <div>
          <div>
            <v-row v-if="this.invoice[0]">
              <v-col md="12">
                <div>{{ $t('expenses.registerMovements.invoices.drawerGenerate.id') }} {{ this.invoiceData.uuid }}</div>
                <div>{{ $t('expenses.registerMovements.invoices.drawerGenerate.supplier') }} {{ this.invoiceData.issuer.name }}</div>
                <div>{{ $t('expenses.registerMovements.invoices.drawerGenerate.status') }} {{ this.invoiceData.status }}</div>
              </v-col>
              <v-col md="12">
                <v-form v-model="isValid" ref="form">
                  <v-data-table
                    :headers="table.headers"
                    :items="table.data"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 20, 30, 40, 50]
                    }"
                    :items-per-page="5"
                    class="elevation-1 table">
                    <template v-slot:[`item.quantity`]="{ item }">
                      <div>
                        {{ item.quantity }}
                      </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                      <div>
                        {{ item.description }}
                      </div>
                    </template>
                    <template v-slot:[`item.category`]="{ item }">
                      <div class="d-flex flex-row align-center">
                        <Select
                          size="fullWidth"
                          item-text="name"
                          item-value="_id"
                          :items="categories.data"
                          :disabled="!categories.data.length || !!item.category"
                          v-model.lazy="item.category"
                          @change="createCategory(item)"
                          :rules="validation.category"
                          :required="true"
                          class="pr-1"
                        />
                        <v-btn
                          icon
                          color="primary"
                          x-small
                          @click="openEditionTypeDialog(item)"
                        >
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:[`item.unitAmount`]="{ item }">
                      <div class="text-right">
                        {{ item.unitAmount | toFix2 | numberWithComma | prefix('$') }}
                      </div>
                    </template>
                    <template v-slot:[`item.totalAmount`]="{ item }">
                      <div class="text-right">
                        {{ item.totalAmount | toFix2 | numberWithComma | prefix('$') }}
                      </div>
                    </template>
                    <template v-slot:[`item.discount`]="{ item }">
                      <div class="text-right">
                        {{ item.discountAmount | toFix2 | numberWithComma | prefix('$') }}
                      </div>
                    </template>
                  </v-data-table>
                </v-form>
              </v-col>
              <v-col md="12" class="d-flex justify-end">
                <v-btn
                  class="mr-2"
                  color="primary"
                  depressed
                  @click="savePayOrder(false)">
                  {{ $t('expenses.registerMovements.invoices.drawerGenerate.buttonSave') }}
                </v-btn>
                 <v-btn
                  color="secondary"
                  depressed
                  @click="opendApplyMovementsDialog">
                  Guardar y Crear movimientos
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog @keydown.esc="successDialog=false" v-model="successDialog" persistent max-width="400px">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          {{ $t('expenses.registerMovements.invoices.drawerGenerate.successDialog.text') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="closeSuccessDialog">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.successDialog.buttonAccept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="editionTypeDialog=false" v-model="editionTypeDialog" content-class="dialog">
      <v-card class="pb-8">
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            depressed
            @click="closeEditionTypeDialog()"
            class="mr-5 mt-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="d-flex flex-column align-center">
          <v-icon class="alert-icon">mdi-alert-circle-outline</v-icon>
          <div class="text mt-4 mb-2">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.editionTypeDialog.text') }}
          </div>
          <v-radio-group v-model="editionType" mandatory>
            <v-radio
              :label="$t('expenses.registerMovements.invoices.drawerGenerate.editionTypeDialog.payOrder')"
              value="payOrder"
            ></v-radio>
            <v-radio
              :label="$t('expenses.registerMovements.invoices.drawerGenerate.editionTypeDialog.all')"
              value="all"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="px-4 justify-center">
          <Button size="regular" type="outlined" @click="closeEditionTypeDialog()">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.editionTypeDialog.buttonCancel') }}
          </Button>
          <Button size="regular" @click="stepEditCategory()">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.editionTypeDialog.buttonConfirm') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="warningDialog=false" v-model="warningDialog" content-class="dialog">
      <v-card class="pb-8">
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            depressed
            @click="closeWarningDialog()"
            class="mr-5 mt-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="d-flex flex-column align-center">
          <v-icon class="alert-icon">mdi-alert-circle-outline</v-icon>
          <div class="text mt-4 mb-2">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.warningDialog.text') }}
          </div>
        </v-card-text>
        <v-card-actions class="px-4 justify-center">
          <Button size="regular" type="outlined" @click="closeWarningDialog()">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.warningDialog.buttonCancel') }}
          </Button>
          <Button size="regular" @click="stepEditCategoryWarning()">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.warningDialog.buttonConfirm') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="editCategoryDialog=false" v-model="editCategoryDialog" content-class="dialog">
      <v-card class="pb-8">
        <div class="d-flex justify-end">
          <v-btn
            fab
            color="transparent"
            depressed
            @click="closeEditCategoryDialog"
            class="mr-5 mt-5"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="dialogTitle">
          {{ $t('expenses.registerMovements.invoices.drawerGenerate.editCategoryDialog.title') }}
        </v-card-title>
        <v-card-text class="d-flex flex-column align-center">
          <div class="d-flex flex-row align-center mt-2 mb-4">
            <div>
              <v-icon class="alert-icon-sm mr-1">mdi-alert-circle-outline</v-icon>
            </div>
            <div>{{ $t('expenses.registerMovements.invoices.drawerGenerate.editCategoryDialog.alert') }}</div>
          </div>
          <div class="dialogBox">
            <div>{{ $t('expenses.registerMovements.invoices.drawerGenerate.editCategoryDialog.concept') }}</div>
            <div class="px-2">
              <v-icon>mdi-arrow-right</v-icon>
            </div>
            <div>
              {{ itemDescription }}
            </div>
          </div>
          <div class="text mt-6 mb-4">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.editCategoryDialog.label') }}
          </div>
          <Select
            size="regular"
            item-text="name"
            item-value="_id"
            :items="categories.data"
            :disabled="!categories.data.length"
            v-model ="newCategoryId"
            @change="updateItemsCategory()"
            required
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="editCategorySuccessDialog=false" v-model="editCategorySuccessDialog" content-class="dialog">
      <v-card class="py-8">
        <v-card-title class="dialogTitle">
          {{ $t('expenses.registerMovements.invoices.drawerGenerate.editCategorySuccessDialog.title') }}
        </v-card-title>
        <v-card-text class="d-flex flex-column align-center">
          <div class="dialogSuccessText">
            <div>{{ $t('expenses.registerMovements.invoices.drawerGenerate.editCategorySuccessDialog.success') }}</div>
          </div>
          <div class="dialogBox">
            <div>{{ $t('expenses.registerMovements.invoices.drawerGenerate.editCategorySuccessDialog.concept') }}</div>
            <div class="px-2">
              <v-icon>mdi-arrow-right</v-icon>
            </div>
            <div>{{ itemDescription }}</div>
            <div class="px-2">
              <v-icon>mdi-arrow-right</v-icon>
            </div>
            <div>{{ newCategoryName }}</div>
          </div>
        </v-card-text>
        <v-card-actions class="px-4 pt-5 justify-center">
          <Button size="regular" @click="closeEditCategorySuccessDialog()">
            {{ $t('expenses.registerMovements.invoices.drawerGenerate.editCategorySuccessDialog.buttonConfirm') }}
          </Button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="openMovementsDialog=false" max-width="410px" v-model="openMovementsDialog">
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <div class="primary--text">
              Crear movimientos
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="mb-2">Se crean movimientos de entrada y salida por comisiones.</div>
          <v-form v-model="isValid" ref="accountForm">
            <v-row>
              <v-col class="py-0" cols="12">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="_id"
                  :items="accounts.data"
                  v-model="accountForm.account"
                  :rules="rules.required"
                  :label="$t('expenses.registerMovements.movements.box')"
                  hide-selected
                  hide-no-data
                  return-object
                  @change="selectType"
                  required
                />
              </v-col>
              <v-col v-if="isAccount" class="py-0" cols="12">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="_id"
                  :items="cashFlowTypes.data"
                  v-model="accountForm.cashFlowType"
                  :rules="rules.required"
                  label="Tipos de ingreso para el movimiento de entrada"
                  required
                />
              </v-col>
              <v-col v-if="isAccount" class="py-0" cols="12">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="_id"
                  :items="categories.data"
                  v-model="accountForm.incomeCategory"
                  :rules="rules.required"
                  label="Categorías de egreso para el movimiento de salida"
                  required
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="closeApplyMovementsDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="applyMovements()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { taxes as taxesTypes } from '@/utils/constants'
import Button from '@/components/elements/Button'
import Select from '@/components/elements/Select'

const PAYMENT_METHODS = {
  'PUE': 'balance',
  'PPD': 'credit'
}

const STATUS_TYPES = {
  'CANCELADO': 'canceled',
  'VIGENTE': 'active'
}

export default {
  name: 'GeneratePayOrder',
  props: {
    isOpen: Boolean,
    invoice: Array
  },
  components: { Button, Select },
  data () {
    return {
      overlay: false,
      editionTypeDialog: false,
      openMovementsDialog: false,
      accounts: {
        loading: false,
        data: []
      },
      kind: null,
      isAccount: false,
      accountForm: {
        account: null,
        incomeCategory: null,
        cashFlowType: null
      },
      rules: {
        required: [v => !!v || 'Required']
      },
      successDialog: false,
      id: null,
      date: null,
      supplier: null,
      status: null,
      table: {
        title: this.$i18n.t('expenses.registerMovements.invoices.drawerGenerate.loading'),
        loading: true,
        headers: [
          { text: this.$i18n.t('expenses.registerMovements.invoices.drawerGenerate.headers.quantity'), value: 'quantity', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.drawerGenerate.headers.concept'), value: 'description', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.drawerGenerate.headers.category'), value: 'category', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.drawerGenerate.headers.cost'), value: 'unitAmount', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.drawerGenerate.headers.amount'), value: 'totalAmount', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.invoices.drawerGenerate.headers.discount'), value: 'discountAmount', sortable: false }
        ],
        data: [],
        total: 0,
        itemsPerPage: 10,
        page: 1
      },
      form: {
        valid: false,
        data: {
          recipe: null,
          quantity: null
        },
        disabled: false,
        isEditing: false
      },
      categories: {
        data: [],
        loading: true
      },
      cashFlowTypes: {
        data: []
      },
      assignedCategories: {
        data: [],
        loading: true
      },
      validation: {
        category: [v => !!v || this.$t('expenses.registerMovements.invoices.drawerGenerate.validations.categoryReq')]
      },
      isValid: false,
      invoiceData: null,
      editCategoryDialog: false,
      editCategorySuccessDialog: false,
      newCategoryId: null,
      selectedItem: null,
      warningDialog: false,
      itemDescription: null,
      newCategoryName: null,
      editionType: 'payOrder'
    }
  },
  watch: {
    invoice: {
      handler: function () {
        const [ data ] = this.invoice
        if (data) {
          this.table.data = data.items
          this.invoiceData = data
          this.loadAssignedCategories()
        }
      }
    },
    selectedItem: function () {
      this.itemDescription = this.selectedItem ? this.selectedItem.description : undefined
    },
    newCategoryId: function () {
      this.newCategoryName = (this.newCategoryId && this.categories.data.length) ? this.categories.data.find(e => this.newCategoryId === e._id).name : undefined
    }
  },
  async mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
    await this.loadCategories()
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  computed: {
    restaurantTaxid () {
      return this.$store.state.currentRestaurant.taxInformation.data.taxId || ''
    },
    open: {
      get: function () {
        return this.isOpen
      },
      set: function (newValue) {
        this.$emit('update:isOpen', newValue)
      }
    }
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') {
        this.resetForm()
        this.open = false
      }
    },
    selectType (item) {
      if (item.kind === 'bank') {
        this.isAccount = false
        this.accountForm.account = item._id
        this.kind = item.kind
      } else {
        this.isAccount = true
        this.accountForm.account = item._id
        this.kind = item.kind
      }
    },
    async applyMovements () {
      this.$refs.accountForm.validate()
      if (this.isValid) {
        await this.savePayOrder(true)
      }
    },
    async opendApplyMovementsDialog () {
      await this.loadaccounts()
      this.openMovementsDialog = true
    },
    closeApplyMovementsDialog () {
      this.accounts.data = []
      this.accountForm.account = null
      this.openMovementsDialog = false
    },
    async loadaccounts (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id
      }

      this.accounts.loading = true
      try {
        const response = await this.$api.get(`/v1/financial/balance-accounts`, params)
        this.accounts.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.accounts.loading = false
    },
    async loadCategories (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.categories.loading = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        this.cashFlowTypes.data = response.data.filter(x => x.type === 'income')
        this.categories.data = response.data.filter(x => x.type === 'outgoing')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.categories.loading = false
    },
    async loadAssignedCategories (params = null) {
      this.overlay = true
      params = params || {
        invoiceId: this.invoiceData.uuid,
        rfc: this.restaurantTaxid
      }
      this.assignedCategories.loading = true
      try {
        const response = await this.$api.get(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}/cashflows`, params)
        this.assignedCategories.data = response
        this.table.data = this.table.data.map(item => {
          const found = response.find(category => {
            if (category.invoice && category.invoice === this.invoiceData.uuid) {
              return true
            }
            return category.description === item.description && category.cashflow
          })
          return {
            ...item,
            category: found
              ? found.cashflow._id
              : undefined
          }
        })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
      this.assignedCategories.loading = false
    },
    async createCategory (item) {
      this.overlay = true
      const payload = {
        'issuer': this.invoiceData.issuer.rfc,
        'cashflows': [
          {
            'cashflowId': item.category,
            'description': item.description
          }
        ]
      }
      try {
        await this.$api.post(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}/cashflows`, payload)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async updateItemsCategory () {
      this.overlay = true
      const payload = {
        'issuer': this.invoiceData.issuer.rfc,
        'cashflows': [
          {
            'id': (this.assignedCategories.data.find(item => item.cashflow && item.cashflow._id === this.selectedItem.category) || {})._id,
            'invoice': this.editionType === 'payOrder' ? this.invoiceData.uuid : undefined,
            'description': this.selectedItem.description,
            'cashflowId': this.newCategoryId
          }
        ]
      }
      try {
        await this.$api.post(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}/cashflows`, payload)
        this.stepEditCategorySuccess()
        await this.loadAssignedCategories()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async savePayOrder (applyMovements) {
      this.$refs.form.validate()

      if (this.isValid) {
        this.overlay = true
        try {
          const payload = {
            invoice: {
              source: this.invoiceData.issuer.name,
              sourceId: this.invoiceData.issuer.rfc,
              folio: this.invoiceData.uuid,
              status: STATUS_TYPES[this.invoiceData.status] || 'active',
              total: this.invoiceData.total,
              subtotal: this.invoiceData.subtotal,
              id: this.invoiceData.id,
              uuid: this.invoiceData.uuid,
              CfdiType: this.invoiceData.paymentType,
              base: 0,
              subtotalTax: this.invoiceData.tax,
              subtotalNotTax: 0,
              xml: this.invoiceData.xml,
              issuedAt: this.invoiceData.issuedAt,
              issuerTaxid: this.invoiceData.issuer.rfc,
              receiverTaxid: this.invoiceData.receiver.rfc,
              issuerTaxName: this.invoiceData.issuer.name,
              receiverTaxName: this.invoiceData.receiver.name,
              type: this.invoiceData.type
            },
            order: {
              restaurant: this.$store.state.currentRestaurant.data._id,
              area: this.$store.state.area.id,
              author: this.$store.state.login.user._id,
              concepts: this.assignConcepts(),
              amount: this.invoiceData.subtotal,
              tax: this.invoiceData.tax,
              total: this.invoiceData.total,
              discount: this.invoiceData.discount,
              paymentMethod: PAYMENT_METHODS[this.invoice[0].paymentType] || ''
            },
            applyMovements: applyMovements
          }

          if (applyMovements && this.kind === 'cash') {
            payload.kind = 'cash'
            payload.account = this.accountForm.account
            payload.cashFlowType = this.accountForm.cashFlowType
            payload.incomeCategory = this.accountForm.incomeCategory
          }

          if (applyMovements && this.kind === 'bank') {
            payload.kind = 'bank'
            payload.date = this.$moment().format('YYYY-MM-DD')
            payload.account = this.accountForm.account
          }

          await this.$api.post(`/v1/invoices`, payload)
          if (applyMovements) this.closeApplyMovementsDialog()
          this.openSuccessDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
        this.closePanel()
      }
    },
    resetForm () {
      this.table.data.map(i => { i.category = null })
      this.$refs.form.resetValidation()
    },
    openSuccessDialog () {
      this.successDialog = true
      this.$emit('updateInvoices')
      this.$emit('updatePayOrders')
    },
    closeSuccessDialog () {
      this.successDialog = false
    },
    closePanel () {
      this.resetForm()
      this.open = false
    },
    assignConcepts () {
      return this.table.data.map(item => ({
        name: item.description,
        satCode: item.taxType || '002',
        quantity: item.quantity,
        taxes: this.assignTax(item),
        unitPrice: item.unitAmount,
        discount: item.discountAmount,
        total: item.totalAmount,
        cashflow: item.category
      }))
    },
    assignTax ({ taxes, taxType, description, taxAmount, taxRate }) {
      return taxes.map(tax => {
        return {
          kind: taxType ? taxesTypes.find(({ satId }) => satId === taxType).name : 'IVA',
          name: description,
          satCode: taxType || '002',
          isRetention: tax.type === 'retention',
          isQuota: tax ? tax.factor.type === 'rate' : true,
          base: taxRate || 0,
          baseAmount: taxAmount || 0
        }
      })
    },
    resetCategory () {
      this.newCategoryId = null
      this.itemDescription = null
      this.selectedItem = null
    },
    openWarningDialog () {
      this.warningDialog = true
    },
    closeWarningDialog () {
      this.warningDialog = false
    },
    openEditCategoryDialog () {
      this.editCategoryDialog = true
    },
    closeEditCategoryDialog () {
      this.editCategoryDialog = false
    },
    stepEditCategory () {
      this.closeEditionTypeDialog()
      if (this.editionType === 'payOrder') {
        this.openEditCategoryDialog()
      } else {
        this.openWarningDialog()
      }
    },
    stepEditCategoryWarning () {
      this.closeWarningDialog()
      this.openEditCategoryDialog()
    },
    openEditCategorySuccessDialog () {
      this.editCategorySuccessDialog = true
    },
    closeEditCategorySuccessDialog () {
      this.resetCategory()
      this.editCategorySuccessDialog = false
    },
    stepEditCategorySuccess () {
      this.closeEditCategoryDialog()
      this.openEditCategorySuccessDialog()
    },
    closeEditionTypeDialog () {
      this.editionTypeDialog = false
    },
    openEditionTypeDialog (item) {
      this.editionType = 'payOrder'
      this.selectedItem = item
      this.editionTypeDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .drawer {
    overflow-y: auto;
  }

  .table tbody tr {
    height: 80px;
    min-height: 80px;
  }

  .alert-icon {
    font-size: 6.25rem !important;
    color: #DF2D2D !important;

  }

  .alert-icon-sm {
    font-size: 1.76rem !important;
    color: #DF2D2D !important;
  }

  .dialog {
    border-radius: 22px;
    width: clamp(450px, 31.46vw, 31.46vw);
  }

  .text {
    text-align: center;
    font-size: 1.125rem;
    line-height: 1.31rem;
    color: #646464;
  }

  .dialogTitle {
    padding-top: 0 !important;
    justify-content: center !important;
    align-items: center !important;
    font-size: 1.75rem !important;
    color: #01D28E;
  }

  .dialogBox {
    display: flex;
    padding: 0.75em 1em;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: #F7FAFD;
    border: 1px solid #B6B6B6;
    box-sizing: border-box;
    border-radius: 6px;
  }

  .dialogSuccessText {
    padding-top: 1em;
    padding-bottom: 2.25em;
    text-align: center;
    font-size: 0.875rem;
    line-height: 1.31rem;
    color: #646464;
  }
</style>
